/* istanbul ignore file */
import { navigate } from '../../../services/web.navigation';

export const SUMMARY_PRODUCTS_INITIAL_STATE = {
  ACCOUNTS: {
    id: 'ACCOUNTS',
    summaryPosition: 0,
    loaded: false,
    closed: true,
    mercury: {
      groupId: 'home_sweb',
      zoneId: 'acc_account',
    },
  },

  CARDS: {
    id: 'CARDS',
    summaryPosition: 1,
    loaded: false,
    closed: true,
    banner: {
      api: null,
      color: 'purple',
      promotions: {
        id: 'creditos',
        name: 'avance',
        creative: 'banner home privado',
        position: '1',
      },
    },
  },

  CREDITS: {
    id: 'CREDITS',
    summaryPosition: 2,
    loaded: false,
    closed: true,
    eventName: 'click_loans_chevron',
    newProductMessage: 'Pide tu Crédito de Consumo',
    newProductAction: () => navigate('#simulador-credito/H'),
  },

  INVESTMENTS: {
    id: 'INVESTMENTS',
    summaryPosition: 3,
    loaded: false,
    closed: true,
    eventName: 'click_investmens_chevron',
    newProductMessage: 'Invierte en un Depósito a Plazo',
    newProductAction: () => navigate('#toma-depositos'),
  },
};
